import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Banner = styled.section`
  ${tw`bg-gray-800 border-b border-blue-100 text-white`};
`;

export const Content = styled.p`
  ${tw`mb-8`};
`;
